export default __webpack_public_path__ + "static/media/fnl_snack.924f0eff.png";